import {ResourceType} from "../../resource/resource.type";
import {FreeWallResponse} from "@rezonence/sdk";

export const responseField: Record<ResourceType, keyof FreeWallResponse> = {
  video: "vid",
  image: "img",
  iframe: "ifs"
};
